var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSriLanka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M22.957 14.96H10.432V1.047h12.525V14.96zM0-.003v16.006h24V-.003H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M22.957 1.04H10.432v13.913h12.525V1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M10.432 1.04h-9.39v13.913h9.39V1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M10.433-.003H9.39v15.998h1.043V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M5.22 1.04H1.042v13.913H5.22V1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M9.397 1.04H5.22v13.913h4.177V1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M16.815 7.737V5.652c0-.345-.525-.697-.525-.697s-.518.352-.518.697H13.68v2.085h1.042V8.75c.002.222.048.441.135.645l-.48.397H12.99V3.387a1.05 1.05 0 00-1.05 1.05v4.5a1.02 1.02 0 00.352.75v1.658h.698v-.825h3.127v1.395h-.697v.69h1.395v-1.388l.637-.697H19.5v1.395h-.698v.69h1.448v-1.388l.637-.697.593-1.883-.518-.9h-4.147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M17.37 5.93v1.185h3.352v.622h.21v-.832H17.58V6.14h3.562v-.21H17.37zm-5.895-4.89h-1.043v1.042h1.043V1.04zm11.482 0h-1.042v1.042h1.042V1.04zM11.475 13.91h-1.043v1.043h1.043V13.91zm11.482 0h-1.042v1.043h1.042V13.91z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSriLanka);
export default __webpack_public_path__ + "static/media/SriLanka.6baf40a28d1e6187e3462d2127eb802d.svg";
export { ForwardRef as ReactComponent };